import "core-js/modules/es6.regexp.replace";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-right-doodle.svg';

const PendingTag = () => import('~/components/functional/TcVars/PendingTag.vue');

export default {
  name: 'CommercialRibbon',
  components: {
    PendingTag
  },
  props: {
    payload: {
      type: Object,
      required: true
    },
    locale: {
      type: Object,
      required: true
    },
    trackingEventCategory: {
      type: String,
      required: true
    }
  },
  computed: {
    type() {
      return this.payload.url ? 'a' : 'span';
    },

    displayTracking() {
      return {
        data: {
          event_category: "".concat(this.trackingEventCategory),
          event_action: 'Display_banner',
          event_label: "".concat(this.payload.label)
        }
      };
    },

    href() {
      if (!this.payload.url) return null;
      return this.payload.url.replace(':market', this.locale.market).replace(':language', this.locale.language);
    }

  },
  methods: {
    clickTracking(evt) {
      this.$root.$emit('generic-tracking', evt, {
        data: {
          event_category: this.trackingEventCategory,
          event_action: 'Click_banner',
          event_label: this.payload.label
        }
      });
    }

  }
};